export default "__VITE_ASSET__DkNPU_LQ__"